<h1 mat-dialog-title class="popup-title w-100">
    Select From and To Dates
   </h1>
   <div mat-dialog-content>
     <mat-form-field>
       <input matInput  [matDatepicker]="picker1" placeholder="From" [(ngModel)]="fromDate" [matDatepickerFilter]="myDateFilter">
       <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
       <mat-datepicker #picker1></mat-datepicker>
     </mat-form-field>
     <mat-form-field>
       <input matInput [matDatepicker]="picker2" placeholder="To" [(ngModel)]="toDate" [matDatepickerFilter]="myDateFilter">
       <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
       <mat-datepicker #picker2></mat-datepicker>
     </mat-form-field>
     <div *ngIf="invalid" >
       <p class="error">Please enter valid dates. Dates cannot be in the future and fields cannot be empty.</p>
     </div>
   </div>
   <div mat-dialog-actions class="div-cel">
     <button class="button mat-div"  mat-button (click)="cancel()">Cancel</button>
     <button class="button mat-div"  mat-button (click)="confirm()">Download</button>
   </div>